import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { connect } from 'react-redux';

import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import useSideRailContext from '../../../../stores/profile/use-side-rail-context';
import ScreenerAppContext from '../../../../stores/screener/screener-app-context';
import styles from './header.module.scss';
import Icon from '../../../atoms/icon';
import { updatePlanHoldings } from '../../../../stores/screener/actions/filter-actions';
import PlanName from '../../../molecules/screener/plan-name';
import { CHANNELS } from '../../../../shared/screener-constants';

const className = augmentClassName(styles);

export const Header = ({
  collapsePresetCategory,
  subPlan,
  updateScreenerPlanHoldings,
  planApiError
}) => {
  const sideRail = useSideRailContext();
  const { channel, yyy, isMobile, queryStringPlan } = useContext(ScreenerAppContext);

  const watchKeyPress = e => {
    if (e.charCode === 13 && e.target.value !== '') {
      e.preventDefault();
      collapsePresetCategory();
      updateScreenerPlanHoldings(e.target.value, subPlan, channel, yyy);
    }
  };
  useEffect(() => {
    if (queryStringPlan) {
      collapsePresetCategory();
      updateScreenerPlanHoldings(queryStringPlan, '', channel, yyy);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <header {...className('root', 'py-6')} role="form">
        <Container>
          <Row>
            <Col {...className('pb-0')}>
              <h3 {...className(isMobile ? 'px-4' : null, 'no-print')}>SCREENER TOOL</h3>
            </Col>
          </Row>
          <Row {...className('align-items-center', 'header-title-row')}>
            <Col>
              <h1 {...className(isMobile ? 'px-4' : null, 'no-print')}>Investment Finder</h1>
            </Col>
            {channel !== CHANNELS.DYNAMICMICROSITES && (
              <Col lg={2}>
                <div
                  data-error-msg={planApiError}
                  {...className(
                    'input-container',
                    'no-print',
                    isMobile ? 'mx-4' : null,
                    planApiError.length ? 'plan-error' : ''
                  )}
                >
                  <input
                    type="text"
                    placeholder="Enter Plan Number"
                    aria-label="Plan Number"
                    name="Plan Number"
                    onKeyPress={watchKeyPress}
                  />
                  <button
                    onClick={() => sideRail.glossary.show()}
                    aria-label="Plan Number Info"
                    title="Plan Number Info"
                    // TIAA Analytics Tracking
                    data-analytics-linkname="GlossaryExpand"
                    data-analytics-section="component"
                    data-analytics-componenttype="TextLink"
                    // END TIAA Analytics Tracking
                  >
                    <Icon variant="QuestionMarkCircledSolid" />
                  </button>
                </div>
              </Col>
            )}
          </Row>
          <PlanName />
        </Container>
      </header>
    </>
  );
};

Header.propTypes = {
  collapsePresetCategory: PropTypes.func,
  planNumberUpdate: PropTypes.func,
  subPlan: PropTypes.string,
  updateScreenerPlanHoldings: PropTypes.func,
  planApiError: PropTypes.string
};

const mapStateToProps = state => {
  return {
    subPlan: state.filterReducer.inputs.subPlan,
    planApiError: state.filterReducer.planApiError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateScreenerPlanHoldings: (searchedPlanNumber, subPlan, channel, yyy) =>
      dispatch(updatePlanHoldings(searchedPlanNumber, subPlan, channel, yyy))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
